// Titres « propres » des îles (accents, formulation), affichés en titre de page.
// Déduits des noms de fichiers puis nettoyés — ⚠️ À FAIRE VALIDER PAR LE MACTe.
// Si une île n'est pas listée, le titre par défaut « Île N » est utilisé.
export const ileTitles = {
  'ile-01': 'La Vierge noire',
  'ile-02': 'Quatre Destins',
  'ile-03': 'La Conquête',
  'ile-04': 'Les Amérindiens',
  'ile-05': 'Les Pirates',
  'ile-06': 'Panorama',
  'ile-07': 'La Controverse',
  'ile-08': "L'Afrique au XVe siècle",
  'ile-09': 'Ouidah',
  'ile-10': 'Le Commerce triangulaire',
  'ile-11': "Les Flux de l'esclavage",
  'ile-12': 'La Traversée',
  'ile-13': 'Le Code Noir',
  'ile-14': 'La Répression',
  'ile-15': "La Société d'habitation",
  'ile-16': 'La Case-nègre',
  // 'ile-17': sujet inconnu dans les fichiers -> "Île 17"
  'ile-18': "Le Jardin de l'esclave",
  'ile-19': 'Le Mur',
  'ile-20': 'La Franc-maçonnerie',
  'ile-21': 'Les Cérémonies',
  'ile-22': 'La Religion',
  'ile-23': 'Les Tambours',
  'ile-24': 'Mascarade et Carnaval',
  'ile-25': 'Saint-Domingue',
  'ile-26': 'Abolition et Rétablissement',
  'ile-27': 'Guerre et Napoléon',
  'ile-28': 'Les Abolitionnistes',
  'ile-29': 'Les Engagés (Darboussier)',
  'ile-30': 'Les États-Unis',
  'ile-31': 'La Terre promise',
  'ile-32': 'Colonisation et Décolonisation',
  'ile-33': "La Mutation de l'image du Noir",
  'ile-34': 'War — Bob Marley',
  'ile-35': 'Aliénations contemporaines',
  'ile-36': 'La Pluralité guadeloupéenne',
  'ile-37': 'Négro-Caraïbes',
  // 'ile-38': sujet inconnu dans les fichiers -> "Île 38"
};
